const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const createAuthMachine = ({
  maxRefreshRetries,
  refreshRetriesDelay,
  url,
  realm,
  clientId,
}) =>
  createMachine(
    {
      /** @xstate-layout N4IgpgJg5mDOIC5QEMCuAXAFgWgLbIGNMBLAOzADozj0BiAQQFUAVACQH0BlRgYR4FFOnANoAGALqJQABwD2sGsVmkpIAB6IAjADYAzBQDsozQBZdATl3bR2zQFYATAYA0IAJ6JdJuxRMGHmgYGfiaiJg66AL6RrmhYeIQk5FSkNAwsHPwASlkA8llikkggcgroSirFGgh2BuYUDgAcBtrmmgF2oY6uHggO3hTaDk4m7aK6deZ22tGxGDj4RGSUADayyBAABKiwYABOm9J7sgBmxCtgtBDKlGQAbrIA1pRxC4nLFGsb27sHR6fnMAIe6yAjIcrKQqFVSlRTKVTVewmCgTTTmdHGOy6Kw2HqIOyOXyaTS6OzmAKNRr2ByzECvBJLZJfLY7faHY5nC60fbHPYUaQrcEnWR7XAUemLJKrdYs37sgEXYGkB5giGkKESGHyOGVUDVAn1Kl2YzmcZWdEudyIExDXw2Ym6TSiRzWGYxOnzBlSig8kW0LL8ZhZACa7AAMrkAOIASQActDirC1QjEOYqYNhs7TaJzLZbHi+gMhk5dOM6qYpgZaRL3slfXtaBHI7kWAmZNrk1VEFT6tpGqWDMTid5tJbejbRBRTcMSeFOqIDFF3TXGS95mBSOVVZBG1GW8w2yUOxUUwge4N+6JKXpGv0TAXtKOKKIAv0rxPtI5q57JR9Xhut3BSBxQIco7kuZhcgAaX4WN2H4AANAAFaMsjjSNDyTE8uwQbASX0Y1wicOxmkXR0x1TJ9zFGaxvB0PxH2-eJf2Sf9N2IbcIBAsDLjUWB0CA8UTnQfYAApjVEUQAEpaBXb02MAkSuMIHjMOPeEcPTF9GmsLFAk-TRGgLHSHGfVEvDCJophMJi3lXcV13YziUhU4hwIYHhmGjAA1ehmH4NSymwvVEGCFFbCmRxDIMRxKQLckDAoWoDH7CYpgsUlbK9P9HMU4CyFc9zIJguDEJQtDYwwzVE3U3V1EQBxzESmL+yaaZHRdeKqJosI7Holo3TmZjazXLAAI4oCuL2MATmm2AkigTZ0CeDcrhuFIHmeBzhvshSJqUihptmuAFqWlbSCVFVwQqDUinbIKNJC3CLFMnrSUpbSrHim1DH6exgmGIx2iyljRswcbnKOubTuW55SG5PZeX5QV0GFUVtrs+Tcv24CoZOshFthjdLtBa7IQkQKdVPPCYoaExTR0RdF2acIC3aAIzP6Jp8IcXSQZGjGIcmw6ZuhgmzrhhGkYFIURTFOScrGpzhbx+bxaJi6QVVG6Kc0O6jweurqjwmxnwpIYTCpBcSU0NndAiChbyMOpmgiRppn53bsecjX+DUaRiD2An-X4AAxANOFYSnOyep1kVNIwcz0CJ-Diq0ECdaiGlaKYmuxRopkGj0dqxpW8q433-cD4Pitg+DkNQvzo1yODGCQgARPz+Hb6Pgvqwt6n6NoC9GJFAjsNmAm0XwWixe2muNGllx-AW9shsB0D2NxxdVzBaD4gSRKEkS9lE3esg3oO4HbsBBTcGSFdY72Vcv7fSEW3fe8e-vsAmfR0ValSIITptD3nTuzTQhhgifmmLzEeNll4lw+NNCAgcwCgTOpsNYUAyBrWSCCLaj9KAoLQRg5aWDZA4M1sqUmapbpakNqeFoyJU6gLJMPToFEM6SQaIEOoNhLZIisJ7b0JDppkNkBQqhUsRTI1lujIhItUHiPQJg7BZASba3JuIL+RtUw-U6BYMIn5mjonMAWbELDTCjCTg4F8Rg7AiOQZAUhqjyHYNkBgGRfIZaozlhjbKyQxHoLcZIjxGBNFk3VBTaq90qY4WopAuoKV57ElsMSCxt5eEtBSiREi3gHCOMQZjZxyiQlqMoZ4ugAYgyhibPuXRp4mqmTTE4doppQiGQLCYMwhhPxWACF4W8xjojulILICAcBVBEIYfEp62BLaNCJNYd6jRPraALNgMkU5eoWlJJmfoRSholPwakdAsyY7922aOIIXhdBrPZiMNmg4LzUSau0dJzojnFxOdKb4rI-gckBBcvuiJQhJUCO7Ue0wySLm6RMCg9hmiOnGKOWcTi6yIxFCC7+1QUrNQiDaJq-ZLZmALDOR2dRXwhAsIxYpgSwZCyUjivRuEemTjeiRNZTQvrp1HMiK8TgC79FaIUhBxyGWC2VgdQqYAWXUwLoMMwBIrzOmJG1Yy1hEXUVHIK9ENsMWMulflUgsr5U4WxD4HMBJFx6FtWmTVk40Q2iMLefVjpDVSvLiLY6at34Sw3Oa+Zphp73P7H1PwbRwiNDAb0J0Rgkq8x6c0SSaImierXsLSuAcg7vyDf3QpkCOj7PsG0YsE9wFhGRFiPsjpnVjHMBm5+B1pqbzfh-UWJ183GzRIPEkMbPxtCsEELh1ifCPgecYFJjpGieuCRIqRZBu1aB0KZFopYrxtFzASCtvQKWmKnqiki5I50uJURUqAVTl0ZyRc+HQUxiSWALo+eFiUkXBBtI4emowEHRCAA */
      predictableActionArguments: true,

      id: "auth-machine",

      context: {
        tokenExpiresIn: 0,
        retryRefreshAttempts: 0,
        maxRefreshRetries: maxRefreshRetries || 3,
        refreshRetriesDelay: refreshRetriesDelay || 5000,
        url: url,
        realm: realm,
        clientId: clientId,
        keycloak: null,
        profile: null,
        error: null,
        remainingTime: 0,
      },

      entry: "createKeycloakClient",

      invoke: {
        src: "setKeycloakEventsHandlers",
      },

      states: {
        init: {
          description: `The initialization of the Keycloak client uses 'login-required' to force the redirection to the Login Page`,

          invoke: {
            src: "initKeycloakClient",
          },

          on: {
            AUTH_SUCCESS: "load user profile",
            AUTH_ERROR: "error",
          },
        },

        "load user profile": {
          invoke: {
            src: "loadUserProfile",
            onDone: {
              target: "authenticated",
              actions: "saveUserProfile",
            },
            onError: "error",
          },
        },

        error: {
          entry: "saveError",

          on: {
            RETRY_LOGIN: "redirect to login",
            LOGOUT: "redirect to logout",
          },
        },

        authenticated: {
          on: {
            LOGOUT: "redirect to logout",
          },

          invoke: [
            {
              src: "observeUserMouseActivity",
            },
            {
              src: "observeTokenExpiringWithin30seconds",
            },
            {
              src: "observeUserKeyboardActivityAny",
            },
            {
              src: "observeDocumentVisibilityState",
            },
          ],

          states: {
            active: {
              after: {
                5000: "inactive",
              },

              on: {
                TOKEN_EXPIRING: "refreshing token",
              },
            },

            inactive: {
              on: {
                ACTIVATE: "active",
                TOKEN_EXPIRING: "tokenExpiring",
              },
            },

            "refreshing token": {
              invoke: {
                src: "refreshToken",

                onError: [
                  {
                    target: "retrying refresh",
                    cond: "canRetry",
                  },
                  "#auth-machine.error",
                ],

                onDone: {
                  target: "active",
                  actions: "resetRetryRefreshAttempt",
                },
              },
            },

            tokenExpiring: {
              on: {
                REFRESH: "refreshing token",

                TOKEN_EXPIRATION_UPDATED: {
                  target: "tokenExpiring",
                  internal: true,
                  actions: "saveRemainingTime",
                },
              },

              invoke: {
                src: "observeTokenExpiration",
              },

              entry: "saveRemainingTime",
              exit: "resetRemainingTime",
            },

            "retrying refresh": {
              entry: "incrementRetryRefreshAttempt",

              after: {
                refreshRetriesDelay: "refreshing token",
              },
            },
          },

          initial: "active",
        },

        "redirect to login": {
          invoke: {
            src: "redirectToLoginForm",
            onDone: "init",
            onError: "error",
          },
        },

        "redirect to logout": {
          invoke: {
            src: "redirectToLogoutForm",
            onError: "error",
          },

          on: {
            RETRY_LOGOUT: "error",
          },
        },
      },

      initial: "init",
    },
    {
      actions: actions,
      guards: guards,
      services: services,
      delays: {
        refreshRetriesDelay: (context) => {
          return context.refreshRetriesDelay || 5000;
        },
      },
    },
  );

export default createAuthMachine;
